export const ServiceEnums = {
    SBCAAS: '6b09812a-b827-4a1a-3a83-08d9fcb7a833',
    OPERATOR_CONNECT: 'bbf5fda6-6a6b-4e5b-59c5-08da06302fb3',
    ACS_DIRECT_ROUTING: '567cd5d5-3c11-4e19-c5a8-08dbc2ce3c21',
    OPERATOR_CONNECT_CONFERENCING: '7cceac4d-0604-4947-c5a9-08dbc2ce3c21',
    TEAMS_PHONE_MOBILE: 'e913d22a-76e8-4ef2-b5a3-08dbc2efc1fc',
    ACS_DIRECT_ROUTING_2: 'eededbf0-5191-43eb-c3ca-08dbf6cdd3f6',
    ZOOM_PEX: '11f75fb0-f994-46c2-83ec-08dd5156db09',
    EIGHTBYEIGHT: 'aa17edc3-48de-453b-0369-08ddb5899289',
    WEBEX: 'bfcca2a6-7222-4fde-5ac0-08de26f66e00',
    DIRECT_ROUTING_GCCH: '73aafc78-0d87-40f9-9484-08de3090823a',
    DIRECT_ROUTING: '6bec0de1-a7f8-4819-89d4-8707c144f430',
};
